import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../../../utility/AppColors";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";

export const useNotificationDetailsPopupStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "box-none",
    },
    mainView: {
      width: "70%",
      maxHeight: "90%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
      borderColor: AppColors.buttonRed_DC2626,
      borderWidth: 1,
    },
    header: {
      marginTop: 20,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    headerTextWrapper: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    headerTitle: {
      ...AppFontStyle.BOLD_ANYBODY_32,
      flexShrink: 1,
    },
    vsImageStyle: {
      height: 80,
      width: 80,
      marginLeft: 10,
    },
    eventDetailsWrapper: {
      backgroundColor: AppColors.black_121212,
    },
    eventDetailsTitle: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
    },
    separator: {
      height: 2,
      backgroundColor: AppColors.grayColor_282828,
      width: "100%",
      marginVertical: 10,
    },
    detailsRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 16,
    },
    column: {
      flex: 1,
    },
    titleDetailWrapper: {
      paddingVertical: 10,
      gap: 6,
    },
    titleText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.gray_C3C3C3,
    },
    descriptionText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
    },
    descriptionWrapper: {
      paddingVertical: 10,
      backgroundColor: AppColors.black_18151b,
    },
    descriptionTitle: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
    },
    organizerWrapper: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingVertical: 10,
    },
    organizerTextWrapper: {
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    organizerTitle: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.white,
    },
    organizerText: {
      ...AppFontStyle.REGULAR_ANYBODY_12,
      color: AppColors.white,
      marginTop: 12,
    },
    chatButton: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 20,
      borderRadius: 10,
      justifyContent: "center",
      alignItems: "center",
      paddingVertical: 15,
      width: 186,
      height: 30,
    },
    chatButtonText: {
      ...AppFontStyle.BOLD_ANYBODY_12,
      color: AppColors.white,
    },
    buttonWrapper: {
      flexDirection: "row",
      marginHorizontal: 10,
      gap: 20,
      marginBottom: 30,
      marginTop: 15,
    },
    acceptRejectButtonStyle: {
      flex: 0.8,
      justifyContent: "center",
      alignItems: "center",
      paddingVertical: 10,
      borderRadius: 10,
      color: AppColors.red_ED1F24,
    },
    buttonText: {
      ...AppFontStyle.BOLD_ANYBODY_12,
    },
    closeIconWrapper: {
      width: 30,
      height: 30,
      borderRadius: 6,
      backgroundColor: AppColors.gray_212222,
      justifyContent: "center",
      alignItems: "center",
      borderWidth: 1,
      borderColor: AppColors.grayColor_393939,
    },
    beltCard: {
      backgroundColor: AppColors.purple_453B50,
      width: "48%",
      borderRadius: 6,
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 10,
      padding: 10,
      borderColor: AppColors.black_161719,
      borderWidth: 1,
      gap: 10,
    },
    beltImage: {
      width: 60,
      height: 59,
      position: "absolute",
      left: -43,
    },
    numberContainer: {
      backgroundColor: AppColors.black,
      borderRadius: 10,
      paddingHorizontal: 15,
      paddingVertical: 5,
      width: 70,
      height: 40,
      justifyContent: "center",
      alignItems: "center",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      mainView: {
        width: "80%",
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_24,
      },
      vsImageStyle: {
        height: 64,
        width: 64,
      },
    },
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "75%",
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_24,
      },
      vsImageStyle: {
        height: 50,
        width: 50,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "60%",
        paddingHorizontal: 15,
        margin: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_20,
      },
      vsImageStyle: {
        height: 44,
        width: 44,
        marginLeft: 5,
      },
      beltImage: {
        width: 60,
        height: 45,
        left: -40,
      },
      numberContainer: {
        width: 69,
        height: 40,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "60%",
        paddingHorizontal: 15,
        margin: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      headerTitle: {
        ...AppFontStyle.BOLD_ANYBODY_18,
      },
      closeIconWrapper: {
        marginLeft: 15,
      },
      vsImageStyle: {
        height: 44,
        width: 44,
        marginLeft: 5,
      },
      beltImage: {
        width: 60,
        height: 45,
        left: -40,
      },
      numberContainer: {
        width: 69,
        height: 40,
      },
    },
  }
);
